module.exports = __webpack_public_path__ + "static/media/checkmark-round-outline.86583a7c.svg";